<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-button @click.prevent="toggleSelectMode()">
          <template v-if="serviceApp.servicesSelectionEnabled">
            <font-awesome-icon icon="check-circle" />
            {{ $t('cancel-select') | capitalize }}
          </template>
          <template v-else>
            <font-awesome-icon icon="check-circle" />
            {{ $t('select') | capitalize }}
          </template>
        </b-button>
        <b-button
          v-if="selectedServices.length > 0"
          @click="controlServices"
          class="ml-3"
        >
          <font-awesome-icon icon="gamepad" />
          {{ $t('control') | capitalize }} {{ selectedServices.length }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import SelectionControlPanel from '@/components/services/SelectionControlPanel.vue';


export default {
  name: 'Services',
  mixins: [
    BaseContextMenuMixin,
  ],
  data() {
    return {
      selectedServices: [],
    };
  },
  computed: {
    ...mapState('app', {
      serviceApp: 'service',
    }),
    ...mapState('breadcrumb', [
      'breadcrumbs',
    ]),
  },
  methods: {
    ...mapActions('app', [
      'toggleServicesSelection',
      'disableServicesSelection',
    ]),
    toggleSelectMode() {
      this.toggleServicesSelection();
    },
    servicesSelected(servicesIds) {
      this.selectedServices = servicesIds;
    },
    controlServices() {
      const panelHandle = this.$showPanel({
        component: SelectionControlPanel,
        width: '500px',
        cssClass: 'panel-1-custom-class',
        keepAlive: false,
        props: {
          servicesIds: this.selectedServices,
        },
      });
      panelHandle.promise
        .then((results) => {
          console.log('Results for panel 1:', results);
        });
    },
  },
  mounted() {
    this.disableServicesSelection();
  },
  created() {
    eventBus.$on('servicesSelected', this.servicesSelected);
  },
  destroyed() {
    eventBus.$off('servicesSelected');
  },
};
</script>

<style scoped>

</style>
